import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/products/extraction-api/docs')({
});

